'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _ExportPopupButton = require('./ExportPopupButton');

var _ExportPopupButton2 = _interopRequireDefault(_ExportPopupButton);

require('./ExportPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportPopup = function ExportPopup(props) {
    return _react2.default.createElement(
        _PopupPanel2.default,
        _extends({}, props, {
            popupId: 'export',
            className: 'ExportPopup' }),
        _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
            className: 'pdf',
            iconName: 'export-pdf',
            format: 'pdf-html',
            title: 'Canvas (PDF)' })),
        _react2.default.createElement(
            'div',
            { className: 'document-title' },
            'Save as document'
        ),
        _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
                    className: 'pdf',
                    iconName: 'export-pdf',
                    format: 'pdf',
                    title: 'PDF' }))
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
                    iconName: 'export-word',
                    format: 'docx',
                    title: 'Word' }))
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
                    iconName: 'export-markdown',
                    format: 'md',
                    title: 'Markdown' }))
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
                    iconName: 'export-text',
                    format: 'txt',
                    title: 'Plain text' }))
            )
        )
    );
};

ExportPopup.propTypes = {
    handlePDFExport: _propTypes2.default.func,
    handleMarkdownExport: _propTypes2.default.func,
    handleDocxExport: _propTypes2.default.func
};

exports.default = ExportPopup;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/export/ExportPopup.js
// module id = 2176
// module chunks = 0